import React from 'react';
import { useAppContext } from '../appContext';
import { Link } from 'react-scroll';
// Components
import { Container, Nav, Navbar } from 'react-bootstrap';
import { FixedNavSpacer, ToggleSwitch } from './globalStyledComponents';
import { useSelector } from 'react-redux';
import { selectData } from '../pages/homeSlice';

export default function NavBar() {
	const { theme, isExpanded, toggleExpanded, closeExpanded } = useAppContext();
	const { avatar_url } = useSelector(selectData);

	return (
		<>
			<FixedNavSpacer />
			<Navbar id='nav' collapseOnSelect={true} expand='lg' expanded={isExpanded} bg={theme === 'light' ? 'light' : 'dark'} variant={theme === 'light' ? 'light' : 'dark'} fixed='top'>
				<Container>
					<Nav.Item>
						<Link to={'Home'} smooth={true} spy={true} activeClass='active' className='nav-link' onClick={closeExpanded}>
							<Navbar.Brand>
								<img src={avatar_url} alt='GitHub Avatar' loading='lazy' width='40' height='40' className='d-inline-block align-top bg-dark rounded-circle nav-logo' />
							</Navbar.Brand>
						</Link>
					</Nav.Item>
					<Navbar.Toggle aria-controls='responsive-navbar-nav' onClick={toggleExpanded} />
					<Navbar.Collapse id='responsive-navbar-nav'>
						<Nav navbarScroll className='me-auto'>
							<Nav.Item>
								<Link to={'Home'} smooth={true} spy={true} activeClass='active' className='nav-link' onClick={closeExpanded}>
									Home
								</Link>
							</Nav.Item>
							<Nav.Item>
								<Link to={'About'} smooth={true} spy={true} activeClass='active' className='nav-link' onClick={closeExpanded}>
									About Me
								</Link>
							</Nav.Item>
							<Nav.Item>
								<Link to={'Offerings'} smooth={true} spy={true} activeClass='active' className='nav-link' onClick={closeExpanded}>
									Mechanical Design
								</Link>
							</Nav.Item>
							<Nav.Item>
								<Link to={'Skills'} smooth={true} spy={true} activeClass='active' className='nav-link' onClick={closeExpanded}>
									Software Skills
								</Link>
							</Nav.Item>
							<Nav.Item>
								<Link to={'Projects'} smooth={true} spy={true} activeClass='active' className='nav-link' onClick={closeExpanded}>
									Github Projects
								</Link>
							</Nav.Item>
							<Nav.Item>
								<Link to={'Contact'} smooth={true} spy={true} activeClass='active' className='nav-link' onClick={closeExpanded}>
									Contact
								</Link>
							</Nav.Item>
						</Nav>
						<Nav>
							<ToggleSwitch />
						</Nav>
					</Navbar.Collapse>
				</Container>
			</Navbar>
		</>
	);
}
